import {FilterEnum} from 'shared/components/date-filter';
import encodeDateFilter from './encode-date-filter';
import {endOfDay, startOfDay} from 'date-fns';
import dateFnsService from 'shared/services/date-fns-service';

interface Props {
  filter: FilterEnum;
  dateInterval?: {startDate: Date; endDate: Date};
  startDateField: string;
  endDateField?: string;
  useDateTime?: boolean;
}

const filterEnumToDateFilter = ({filter, dateInterval, ...rest}: Props) => {
  const today = startOfDay(new Date());
  const yesterday = dateFnsService.subDays(today, 1);
  const last3Hours = dateFnsService.subHours(new Date(), 3);

  if (filter === FilterEnum.today)
    return encodeDateFilter({
      ...rest,
      startDate: today,
      endDate: endOfDay(today),
    });

  if (filter === FilterEnum.yesterday)
    return encodeDateFilter({
      ...rest,
      startDate: yesterday,
      endDate: endOfDay(yesterday),
    });

  if (filter === FilterEnum.last3hours)
    return encodeDateFilter({
      ...rest,
      startDate: last3Hours,
      endDate: endOfDay(today),
    });

  return encodeDateFilter({
    ...rest,
    startDate: dateInterval!.startDate,
    endDate: dateInterval!.endDate,
  });
};

export default filterEnumToDateFilter;
